import React from 'react'
import styled from 'styled-components'
import { CardView } from 'src/Component/Card'
import { Title1 } from 'src/Styles/text-styles'
import { ReactComponent as SettingIcon } from 'images/provider_desktop.svg'
import { ReactComponent as IPAddressIcon } from 'images/ip_address_desktop.svg'
import { ReactComponent as ServerLocationIcon } from 'images/server_location_desktop.svg'
import { ReactComponent as SeverHostIcon } from 'images/server_host_desktop.svg'
import { ReactComponent as NetworkTypeIcon } from 'images/network_type_desktop.svg'
import { ReactComponent as LocationIcon } from 'images/location_desktop.svg'
import InnerCard from 'src/Home/AdditionalDetail/DesktopView/InnerCard'
import { localize } from 'src/lib/localize'
import { NETWORK_TYPE_MOBILE } from 'src/Common/Constant'
import { theme } from 'src/Styles/theme'

const MainContainer = styled.div`
  flex: 1;
  display: flex;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  justify-content: space-around;
`

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & > * {
    margin: 8px;
  }
`
const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${theme.colors.appBackgroundColor};
  & > * {
    margin: 8px;
  }
`

const Title = styled(Title1)`
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
  @media (min-width: 480px) {
    margin-right: 4px;
    margin-left: 4px;
    margin-bottom: 8px;
  }
  @media (max-width: 480px) {
    margin-right: 4px;
    margin-left: 4px;
    margin-bottom: 8px;
  }
  @media (min-width: 768px) {
    margin-right: 8px;
    margin-left: 8px;
    margin-bottom: 16px;
  }
`

interface Props {
  network_type?: string
  serverHost: string
  location?: string
  ipAddress?: string
  ssid?: string
  serverLocation: string
  showAllCategory?: boolean
  provider?: string
}

const additionalDetailText = localize('TITLE')('Additional Details')
const serverHostText = localize('TITLE')('Server Host')
const ipAddressText = localize('TITLE')('IP Address')
const serverLocationText = localize('TITLE')('Server Location')
const locationText = localize('TITLE')('Location')
const providerText = localize('TITLE')('Provider')
const networkTypeText = localize('TITLE')('Network Type')

const DesktopView = ({
  serverHost,
  ipAddress,
  serverLocation,
  showAllCategory = false,
  provider,
  network_type,
  location,
}: Props) => {
  const networkTypeDesc =
    network_type === NETWORK_TYPE_MOBILE
      ? localize('LABEL')('Mobile Data')
      : localize('LABEL')('Wi-Fi')
  return (
    <MainContainer>
      <CardView
        style={{
          pointerEvents: 'none',
          alignItems: showAllCategory ? 'center' : 'left',
        }}
      >
        <Container style={{ alignItems: showAllCategory ? 'center' : 'left' }}>
          <Title style={{ alignItems: showAllCategory ? 'center' : 'left' }}>
            {additionalDetailText}
          </Title>
          <ItemContainer>
            {showAllCategory && (
              <InnerContainer>
                {network_type && (
                  <InnerCard
                    title={networkTypeText}
                    description={networkTypeDesc}
                    Icon={NetworkTypeIcon}
                  />
                )}
                {provider && (
                  <InnerCard
                    title={providerText}
                    description={provider}
                    Icon={SettingIcon}
                  />
                )}
              </InnerContainer>
            )}
            <InnerContainer>
              <InnerCard
                title={serverHostText}
                description={serverHost}
                Icon={SeverHostIcon}
              />
              <InnerCard
                title={serverLocationText}
                description={serverLocation}
                Icon={ServerLocationIcon}
              />
            </InnerContainer>
            {showAllCategory && (
              <InnerContainer>
                {location && (
                  <InnerCard
                    title={locationText}
                    description={location}
                    Icon={LocationIcon}
                  />
                )}
                <InnerCard
                  title={ipAddressText}
                  description={ipAddress!!}
                  Icon={IPAddressIcon}
                />
              </InnerContainer>
            )}
          </ItemContainer>
        </Container>
      </CardView>
    </MainContainer>
  )
}

export default DesktopView
